import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'sbTimeFormat'
})

export class SbTimeFormatPipe implements PipeTransform {

    transform(value: number): string {
      if (value <= 60) {
          return `${value} seconds`;
      } else {
        const minutes = Math.floor(value / 60);
        const seconds = value % 60;
        const paddedSeconds = seconds.toString().padStart(2, '0');
        return `${minutes}:${paddedSeconds} minutes`;
      }
    }
  }

